import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';

/**
 * I don't think we actually use this component right now, so for the time being,
 * we won't worry about specifying prop types and figuring out what from the
 * spread of `...rest` is actually necessary.
 */
/* eslint-disable */
export function CustomRenderedImage({ id, url, ...rest }) {
  return <Image key={id} src={url} {...rest} />;
}
